module.exports = __webpack_public_path__ + "img/焦栀子.477f726a.jpg";